import type MultiSelect from '../index';

export class MaxSelected {
    private readonly ms: MultiSelect;
    private errorElement: HTMLDivElement | null = null;
    private countSpan: HTMLElement | null = null;
    private hideTimeout: number | null = null;

    constructor(multiSelect: MultiSelect) {
        this.ms = multiSelect;
    }

    public createErrorElement(): HTMLDivElement {
        const el = document.createElement('div');
        el.className = 'max-selected-error';
        el.setAttribute('aria-live', 'polite');
        this.errorElement = el;

        return el;
    }

    public setCountSpan(span: HTMLElement): void {
        this.countSpan = span;
    }

    public canSelectMore(): boolean {
        if (!this.ms.maxSelected) {
            return true;
        }

        const currentCount = this.ms.select.selectedOptions.length;

        return currentCount < this.ms.maxSelected;
    }

    public showError(): void {
        if (!this.errorElement || !this.ms.maxSelected) {
            return;
        }

        this.errorElement.textContent = this.ms.maxSelectedMessage.replace('{max}', String(this.ms.maxSelected));
        this.errorElement.classList.add('visible');
        this.clearActiveTimeout();
        this.hideTimeout = window.setTimeout(() => this.hideError(), 3000);
    }

    public hideError(): void {
        if (this.errorElement) {
            this.errorElement.classList.remove('visible');
        }
        this.clearActiveTimeout();
    }

    public updateCount(count: number): void {
        if (!this.countSpan) {
            return;
        }

        this.countSpan.textContent = String(count);

        const info = this.countSpan.closest('.max-selected-info');

        if (info) {
            const isAtLimit = !!this.ms.maxSelected && count >= this.ms.maxSelected;
            info.classList.toggle('at-limit', isAtLimit);
        }
    }

    public destroy(): void {
        this.clearActiveTimeout();
        this.errorElement = null;
        this.countSpan = null;
    }

    private clearActiveTimeout(): void {
        if (this.hideTimeout !== null) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
    }
}